var map = {
	"./arrow.svg": [
		99,
		11
	],
	"./burger.svg": [
		100,
		12
	],
	"./camera.svg": [
		101,
		13
	],
	"./email.svg": [
		102,
		14
	],
	"./facebook.svg": [
		103,
		15
	],
	"./instagram.svg": [
		104,
		16
	],
	"./location.svg": [
		105,
		17
	],
	"./phone.svg": [
		106,
		18
	],
	"./project.svg": [
		107,
		19
	],
	"./right.svg": [
		108,
		20
	],
	"./spinner.svg": [
		109,
		21
	],
	"./video.svg": [
		110,
		22
	],
	"./voucher.svg": [
		111,
		23
	],
	"./youtube.svg": [
		112,
		24
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 95;
module.exports = webpackAsyncContext;